import React, { Suspense, lazy, useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import ".././../styles/diet/diet.css";
import { useGetFetch, useUpdateFetch } from "../../data/Queries";
import {
  dietUnitDelete,
  dietUnitGet,
  dietUnitGetKey,
} from "../../data/ApiEndpoints";
import { useSelector } from "react-redux";
import { selectToken } from "../../components/auth/auth.selector";
import { formatDate } from "../../utils/utilityfunc";
import Loader from "../../components/ui/Loader";
import { toast } from "react-toastify";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import DUFilters from "../../components/diet/units/DUFilters";
import DUTable from "../../components/diet/units/DUTable";
import { showConfirmAlert } from "../../components/components-react/ReactAlert";
import HelmetWrapper from "../../HelmetWrapper";

const DietForm = lazy(() => import("../../components/diet/units/DietForm"));

const DietUnit = () => {
  const token = useSelector(selectToken);
  const [search, setSearch] = useState("");

  // modals
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState({
    status: false,
    data: null,
  });

  // get diet unit
  const [isPage, setIsPage] = useState(0);
  const [unitFilters, setUnitFilters] = useState({ search });
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const {
    data: dietUnitData,
    isLoading: isLoadingDietUnit,
    isFetching: isFetchingDietUnit,
    refetch: refetchDietUnit,
  } = useGetFetch({
    token,
    url: dietUnitGet,
    key: dietUnitGetKey,
    filters: unitFilters,
    isPage: isPage + 1,
  });

  // diet unit delete
  const { mutateAsync: deleteUnit, isLoading: isLoadingDltUnit } =
    useUpdateFetch({
      key: dietUnitGetKey,
      url: dietUnitDelete,
      token,
    });

  // async function handleUnitDelete1(uid) {
  //   try {
  //     if (window.confirm("Do you really want to delete this unit?")) {
  //       const { status, message } = await deleteUnit({ uid });
  //       if (status) {
  //         toast.success(message ? message : "Success!");
  //       } else {
  //         toast.error(message ? message : "Server Error!");
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  const handleUnitDelete = async (uid) => {
    const handleConfirm = async () => {
      if (uid) {
        try {
          const { status, message } = await deleteUnit({ uid });
          if (status) {
            toast.success(message ? message : "Success!");
          } else {
            toast.error(message ? message : "Server Error!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete Unit");
        }
      } else {
        toast.error("UID required!");
      }
    };

    showConfirmAlert(
      handleConfirm,
      `Are you sure, you want to delete this unit!`
    );
  };

  function handleSearchBtn() {
    try {
      setUnitFilters({ search });
      setSearchFilterApplied(true);
    } catch (error) {
      console.log(error);
      setSearchFilterApplied(false);
    }
  }

  // function isData() {
  //   try {
  //     if (isLoadingDietUnit || isFetchingDietUnit || isLoadingDltUnit) {
  //       return true;
  //     }
  //     return false;
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  useEffect(() => {
    try {
      refetchDietUnit();
    } catch (error) {
      console.log(error);
    }
  }, [isPage, unitFilters]);

  useEffect(() => {
    if (search?.length === 0) {
      setSearchFilterApplied(false);

      try {
        setUnitFilters({});
      } catch (error) {
        console.log(error);
      }
    }
  }, [search]);

  const dietUnitColumns = [
    // {
    //   dataField: "uid",
    //   text: "ID",
    //   formatter: (data) => (
    //     <span className="tb-data">{data?.replace(/_/g, " ") || "NA"}</span>
    //   ),
    // },
    {
      dataField: "unit_name",
      text: "Unit Name",
      formatter: (data) => (
        <span className="tb-data">{data?.replace(/_/g, " ") || "NA"}</span>
      ),
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (data) => (
        <span className="tb-data">{formatDate(+data) || "-"}</span>
      ),
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27 bold"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() => setIsEditModalOpen({ status: true, data: row })}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M3.62891 17.3603V20.3254C3.62891 20.5985 3.84349 20.8131 4.1166 20.8131H7.08175C7.20855 20.8131 7.33535 20.7643 7.42313 20.6668L18.0743 10.0254L14.4166 6.36775L3.77521 17.0091C3.67768 17.1067 3.62891 17.2237 3.62891 17.3603ZM20.9029 7.19682C20.9933 7.10658 21.065 6.9994 21.114 6.88141C21.1629 6.76341 21.1881 6.63692 21.1881 6.50918C21.1881 6.38143 21.1629 6.25495 21.114 6.13695C21.065 6.01896 20.9933 5.91177 20.9029 5.82154L18.6205 3.53915C18.5302 3.44873 18.4231 3.37699 18.3051 3.32805C18.1871 3.2791 18.0606 3.25391 17.9328 3.25391C17.8051 3.25391 17.6786 3.2791 17.5606 3.32805C17.4426 3.37699 17.3354 3.44873 17.2452 3.53915L15.4603 5.32409L19.1179 8.98176L20.9029 7.19682Z"
                fill="url(#paint0_linear_14023_4477)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_14023_4477"
                  x1="3.62891"
                  y1="11.6344"
                  x2="21.1881"
                  y2="11.6344"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.0447915" stopColor="#B4000B" />
                  <stop offset="1" stopColor="#DD0000" />
                </linearGradient>
              </defs>
            </svg>
          </button>
          <button
            className="actionBtn icon delete"
            disabled={isLoadingDltUnit}
            onClick={() => handleUnitDelete(row?.uid)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M8.49846 4.3041H11.4978C11.4978 3.90637 11.3398 3.52492 11.0585 3.24369C10.7773 2.96245 10.3958 2.80445 9.99811 2.80445C9.60038 2.80445 9.21893 2.96245 8.9377 3.24369C8.65646 3.52492 8.49846 3.90637 8.49846 4.3041ZM7.4987 4.3041C7.4987 3.64121 7.76203 3.00548 8.23076 2.53675C8.69949 2.06802 9.33522 1.80469 9.99811 1.80469C10.661 1.80469 11.2967 2.06802 11.7655 2.53675C12.2342 3.00548 12.4975 3.64121 12.4975 4.3041H17.4963C17.6289 4.3041 17.7561 4.35676 17.8498 4.45051C17.9435 4.54425 17.9962 4.6714 17.9962 4.80398C17.9962 4.93655 17.9435 5.0637 17.8498 5.15745C17.7561 5.25119 17.6289 5.30386 17.4963 5.30386H16.4426L15.2489 15.6454C15.1645 16.3764 14.8143 17.0509 14.265 17.5405C13.7156 18.0302 13.0054 18.3007 12.2696 18.3008H7.72664C6.99077 18.3007 6.2806 18.0302 5.73125 17.5405C5.18191 17.0509 4.83173 16.3764 4.74735 15.6454L3.55363 5.30386H2.49988C2.3673 5.30386 2.24016 5.25119 2.14641 5.15745C2.05267 5.0637 2 4.93655 2 4.80398C2 4.6714 2.05267 4.54425 2.14641 4.45051C2.24016 4.35676 2.3673 4.3041 2.49988 4.3041H7.4987ZM8.99834 8.30315C8.99834 8.17057 8.94568 8.04343 8.85193 7.94968C8.75819 7.85593 8.63104 7.80327 8.49846 7.80327C8.36588 7.80327 8.23874 7.85593 8.14499 7.94968C8.05125 8.04343 7.99858 8.17057 7.99858 8.30315V14.3017C7.99858 14.4343 8.05125 14.5615 8.14499 14.6552C8.23874 14.7489 8.36588 14.8016 8.49846 14.8016C8.63104 14.8016 8.75819 14.7489 8.85193 14.6552C8.94568 14.5615 8.99834 14.4343 8.99834 14.3017V8.30315ZM11.4978 7.80327C11.3652 7.80327 11.238 7.85593 11.1443 7.94968C11.0505 8.04343 10.9979 8.17057 10.9979 8.30315V14.3017C10.9979 14.4343 11.0505 14.5615 11.1443 14.6552C11.238 14.7489 11.3652 14.8016 11.4978 14.8016C11.6303 14.8016 11.7575 14.7489 11.8512 14.6552C11.945 14.5615 11.9976 14.4343 11.9976 14.3017V8.30315C11.9976 8.17057 11.945 8.04343 11.8512 7.94968C11.7575 7.85593 11.6303 7.80327 11.4978 7.80327Z"
                fill="black"
              />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <HelmetWrapper title="WTF: Diet Unit">
      <>
        <Modal
          isOpen={isEditModalOpen?.status}
          onRequestClose={() =>
            setIsEditModalOpen({ status: false, data: null })
          }
          contentLabel="Edit Diet Units Modal"
          ariaHideApp={false}
        >
          <Suspense fallback={<Loader />}>
            <DietForm
              onClose={() => setIsEditModalOpen({ status: false, data: null })}
              data={isEditModalOpen?.data}
            />
          </Suspense>
        </Modal>

        <Modal
          isOpen={isAddModalOpen}
          onRequestClose={() => setIsAddModalOpen(false)}
          contentLabel="Add Diet Unit Modal"
          ariaHideApp={false}
        >
          <Suspense fallback={<Loader />}>
            <DietForm onClose={() => setIsAddModalOpen(false)} />
          </Suspense>
        </Modal>

        <Container
          className="bg-cloud-k dietMealsParentContainer px-50px"
          fluid
        >
          <Row>
            <Col>
              <MealsStructure text={"All Measuring unit"} />
            </Col>
          </Row>
          <Row>
            <Col>
              <DUFilters
                search={search}
                setSearch={setSearch}
                searchFilterApplied={searchFilterApplied}
                onClickSearch={handleSearchBtn}
                onClickAdd={() => setIsAddModalOpen(true)}
                callFunction={() => {
                  try {
                    refetchDietUnit();
                  } catch (error) {
                    console.log(error);
                  }
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <DUTable
                decryptedText={token}
                tbData={
                  Array.isArray(dietUnitData?.data) ? dietUnitData?.data : []
                }
                isPage={isPage}
                setIsPage={setIsPage}
                pagination={dietUnitData?.pagination || []}
                dietUnitColumns={dietUnitColumns}
                callFunction={() => {
                  try {
                    refetchDietUnit();
                  } catch (error) {
                    console.log(error);
                  }
                }}
              />
            </Col>
          </Row>
        </Container>

        {/* <section className="container-k small p-2">
        <div className="grid-k gap-1-k">
          <header className="flex-k js-between-k items-center-k my-2">
            <h3 className="bold-text dark-text m-0">Diet Meal Units</h3>
            <button
              onClick={() => setIsAddModalOpen(true)}
              className="btn-k btn-primary-k bold-text fs-normal-text"
            >
              Add Diet Unit
            </button>
          </header>

          <div className="flex-k w-full-k gap-1-k">
            <div className="w-full-k relative-k">
              <input
                type="text"
                value={search}
                className="input-k dark dark-text"
                placeholder="Search by name.."
                onChange={(e) => setSearch(e.target.value)}
              />
              <Icons
                onClick={handleSearchBtn}
                size="25"
                className="absolute-end-k cursor-pointer-k"
                name={"search"}
              />
            </div>
            <button
              onClick={() => {
                setUnitFilters({ search: "" });
                setSearch("");
              }}
              className="btn-k px-4 fs-normal-text dark-bg-k"
            >
              Reset
            </button>
          </div>
        </div>

        {isData() ? (
          <div className="flex-k js-center-k items-center-k h-50vh-k">
            <Loader size={"medium"} />
          </div>
        ) : (
          <div>
            <LightTable
              columns={dietUnitColumns}
              data={Array.isArray(dietUnitData?.data) ? dietUnitData?.data : []}
            />
            <PaginationLight
              isPage={isPage}
              onChangePage={setIsPage}
              pagination={dietUnitData?.pagination || []}
            />
          </div>
        )}

        <ReactModal
          onRequestClose={() => setIsAddModalOpen(false)}
          ariaHideApp={false}
          isOpen={isAddModalOpen}
        >
          <div className="modal-body-k bg-white small rounded-4">
            <ModalHeader
              title={"Add Unit"}
              onClick={() => setIsAddModalOpen(false)}
            />
            <Suspense fallback={<Loader />}>
              <DietForm onClose={() => setIsAddModalOpen(false)} />
            </Suspense>
          </div>
        </ReactModal>

        <ReactModal
          onRequestClose={() =>
            setIsEditModalOpen({ status: false, data: null })
          }
          ariaHideApp={false}
          isOpen={isEditModalOpen?.status}
        >
          <div className="modal-body-k bg-white small rounded-4">
            <ModalHeader
              title={"Edit Unit"}
              onClick={() => setIsEditModalOpen({ status: false, data: null })}
            />
            <Suspense fallback={<Loader />}>
              <DietForm
                onClose={() =>
                  setIsEditModalOpen({ status: false, data: null })
                }
                data={isEditModalOpen?.data}
              />
            </Suspense>
          </div>
        </ReactModal>
      </section> */}
      </>
    </HelmetWrapper>
  );
};

export default DietUnit;
